import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { getActivityLog } from '../helpers/activityLog';
import { mapOngoingCalls } from '../helpers/jssip';
import rootReducer from '../reducers';
const isProd = process.env.NODE_ENV === 'production';
Sentry.init({
    dsn: 'https://88bcda3033ac4c73856822e58731fb79@o4504996433362944.ingest.sentry.io/4505000397897728',
    release: version,
    environment: process.env.NODE_ENV,
    integrations: [new Sentry.BrowserTracing() /* , new Sentry.Replay() */],
    // Performance Monitoring
    tracesSampleRate: isProd ? 0.1 : 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: isProd ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend: (event) => {
        const ongoingCalls = mapOngoingCalls();
        const activityLog = getActivityLog();
        const context = { activityLog };
        if (ongoingCalls) {
            context.ongoingCalls = ongoingCalls;
        }
        if (event.contexts) {
            event.contexts['SIP UA'] = context;
        }
        return event;
    },
});
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    actionTransformer: (action) => {
        // We're not really interested in logging these and there are a lot of them
        if (action.type === 'SET_PHONE_STATUS') {
            return null;
        }
        return action;
    },
});
const createStore = (preloadedState) => configureStore({
    reducer: rootReducer,
    preloadedState,
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});
export default createStore;
